import type { InterventionSectionCardGridProps } from "./intervention-section-card-grid.type";

import { Splitter } from "antd";

import { useHideInterventionSectionRecommendation } from "@/modules/intervention/intervention-section-recommendation";

import "./intervention-section-card-grid.style.less";

const { Panel } = Splitter;

const InterventionSectionCardGrid = ({
  forms,
  recommendation,
  tabs,
}: InterventionSectionCardGridProps) => {
  const hideRecommendation = useHideInterventionSectionRecommendation();

  return (
    <Splitter className="intervention-section-card-grid">
      <Panel defaultSize="60%">
        {hideRecommendation ? (
          forms
        ) : (
          <Splitter orientation="vertical">
            <Panel min={64}>{forms}</Panel>
            <Panel defaultSize={150} min={64}>
              {recommendation}
            </Panel>
          </Splitter>
        )}
      </Panel>
      <Panel min={308} max="60%">
        {tabs}
      </Panel>
    </Splitter>
  );
};

export default InterventionSectionCardGrid;
